import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface CheckboxDialogData {
  title: string;
  message: string;
  okButtonLabel: string;
  rejectButtonLabel: string;
}

@Component({
  selector: 'app-checkbox-dialog',
  templateUrl: './checkbox-dialog.component.html',
  styleUrls: ['./checkbox-dialog.component.scss'],
  standalone: false,
})
export class CheckboxDialogComponent {
  dialogRef = inject<MatDialogRef<CheckboxDialogComponent>>(MatDialogRef);
  dialogData = inject<CheckboxDialogData>(MAT_DIALOG_DATA);

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

  onDismissClick(): void {
    this.dialogRef.close();
  }
}
